export default function DesignPhilosophy() {
    return (
        <section className="py-16 md:py-24 bg-cream-dark -mx-6 md:-mx-8 px-6 md:px-8">
            <div className="max-w-3xl mx-auto lg:mx-0">
                <h2 className="text-2xl md:text-title font-fraunces mb-8">
                    How I Think About Design
                </h2>

                <div className="space-y-6 text-body-lg text-warm-gray-600">
                    <p>
                        I don't see design as decoration or trend-following.
                        <br />
                        For me, good design starts with listening — to the brief, the constraints, and the spaces in between.
                    </p>

                    <p>
                        I care about clarity, rhythm, and the small decisions that often go unnoticed but shape how something feels.
                    </p>

                    <p className="text-warm-gray-700">
                        The goal is not to impress, but to make things make sense — and feel right.
                    </p>
                </div>
            </div>
        </section>
    );
}
